export const SpecificDurationDropDown = [
  {
    key: 'minutes',
    label: 'Minute(s)'
  },
  {
    key: 'hours',
    label: 'Hour(s)'
  },
  {
    key: 'days',
    label: 'Day(s)'
  },
  {
    key: 'weeks',
    label: 'Week(s)'
  },
  {
    key: 'months',
    label: 'Month(s)'
  },
  {
    key: 'years',
    label: 'Year(s)'
  },
]